module.exports = __webpack_public_path__ + "img/Mickie-Javaid-Camua-mountain-istanbul.f1809cfd.jpg";